/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the LnrpDownloadResponseDto interface.
 */
export function instanceOfLnrpDownloadResponseDto(value) {
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    if (!('url' in value) || value['url'] === undefined)
        return false;
    return true;
}
export function LnrpDownloadResponseDtoFromJSON(json) {
    return LnrpDownloadResponseDtoFromJSONTyped(json, false);
}
export function LnrpDownloadResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fileName': json['fileName'],
        'url': json['url'],
    };
}
export function LnrpDownloadResponseDtoToJSON(json) {
    return LnrpDownloadResponseDtoToJSONTyped(json, false);
}
export function LnrpDownloadResponseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'fileName': value['fileName'],
        'url': value['url'],
    };
}
